import React from 'react';

export interface IComponentProps {
  className?: string;
  content: string;
  worktime: string;
  helper: {
    content: string;
    url?: string;
  }[];
}

export default function Bulletin(props: IComponentProps) {
  return (
    <div className={'divide-y p-4 ' + props.className || ''}>
      <h1 className="text-center text-sm text-blue-600 p-2">提示信息</h1>
      <div className="text-xs text-gray-600 tracking-wider">
        <p className="my-2">{props.content}</p>
        <p>如遇座席忙或没有客服在线，您可以通过以下方式获取使用帮助：</p>
        <ul className="ml-6 mx-2 list-disc">
          {props.helper.map((v, i) => (
            <li key={'help-' + i}>
              {v.url ? (
                <a className="text-blue-600" target="_blank" href={v.url}>
                  {v.content}
                </a>
              ) : (
                v.content
              )}
            </li>
          ))}
        </ul>
        <p dangerouslySetInnerHTML={{ __html: props.worktime }}></p>
        <p className="my-2">
          注意：关闭本窗口将无法收到我们的回复，对话未结束前请勿关闭本窗口。
        </p>
      </div>
    </div>
  );
}
